import { ArcadeModal, ArcadeModalProps } from '@cash-design-system/react'

import { useModalSharedProps } from '../utils/useModalSharedProps'

export type { ArcadeModalVariant, ArcadeModalProps } from '@cash-design-system/react'

export interface ModalProps extends Omit<ArcadeModalProps, 'ariaLabel' | 'closeButtonProps' | 'backButtonProps'> {
  closeButtonProps?: Partial<ArcadeModalProps['closeButtonProps']>
  backButtonProps?: Partial<ArcadeModalProps['backButtonProps']>
}

export const Modal = (props: ModalProps) => {
  const sharedProps = useModalSharedProps(props)

  return <ArcadeModal {...sharedProps} />
}

export default Modal
